import * as React from 'react';
import { SVGProps } from 'react';
export const GooglePayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={62} height={24} fill="none" {...props}>
    <path
      fill="#fff"
      d="M28.952 11.672v7.076h-2.26V1.276h5.993c1.519 0 2.814.503 3.874 1.509 1.083 1.005 1.625 2.234 1.625 3.684 0 1.485-.542 2.713-1.625 3.707-1.048.995-2.343 1.486-3.874 1.486h-3.733v.011Zm0-8.245V9.52h3.78c.895 0 1.648-.304 2.237-.9.6-.597.907-1.322.907-2.14 0-.808-.306-1.521-.907-2.117-.589-.62-1.33-.924-2.237-.924h-3.78v-.012ZM44.095 6.398c1.672 0 2.991.444 3.957 1.333.965.889 1.448 2.105 1.448 3.65v7.367h-2.155v-1.66h-.094c-.93 1.368-2.178 2.046-3.732 2.046-1.331 0-2.438-.386-3.333-1.17-.895-.783-1.342-1.753-1.342-2.923 0-1.24.47-2.222 1.413-2.947.942-.737 2.202-1.1 3.768-1.1 1.342 0 2.449.246 3.309.737v-.515c0-.783-.307-1.438-.93-1.988a3.204 3.204 0 0 0-2.19-.819c-1.26 0-2.262.527-2.992 1.59l-1.99-1.239c1.095-1.579 2.72-2.362 4.863-2.362Zm-2.92 8.678c0 .585.248 1.076.754 1.462.494.386 1.083.585 1.754.585.954 0 1.802-.351 2.544-1.053s1.118-1.52 1.118-2.468c-.706-.55-1.684-.83-2.943-.83-.919 0-1.684.222-2.297.655-.624.456-.93 1.006-.93 1.649ZM61.794 6.784 54.258 24h-2.332l2.803-6.023-4.97-11.193h2.462l3.58 8.584h.046l3.486-8.584h2.46Z"
    />
    <path
      fill="#4285F4"
      d="M19.96 10.246c0-.733-.066-1.433-.189-2.107h-9.476V12h5.458a4.641 4.641 0 0 1-2.026 3.11v2.504h3.25c1.896-1.744 2.983-4.322 2.983-7.367Z"
    />
    <path
      fill="#34A853"
      d="M13.727 15.109c-.904.606-2.068.96-3.43.96-2.632 0-4.865-1.761-5.665-4.136h-3.35v2.583a10.095 10.095 0 0 0 9.014 5.518c2.725 0 5.014-.89 6.68-2.422l-3.248-2.503Z"
    />
    <path
      fill="#FABB05"
      d="M4.317 10.018c0-.667.112-1.312.316-1.917V5.518H1.282a9.913 9.913 0 0 0-1.073 4.5c0 1.618.387 3.146 1.073 4.499l3.35-2.582a6.005 6.005 0 0 1-.315-1.917Z"
    />
    <path
      fill="#E94235"
      d="M10.296 3.965c1.487 0 2.82.509 3.87 1.503l2.88-2.857C15.297.993 13.018 0 10.296 0a10.097 10.097 0 0 0-9.015 5.518l3.351 2.583c.8-2.375 3.033-4.136 5.664-4.136Z"
    />
  </svg>
);
